import {
  Component,
  OnInit,
  Injector,
  ChangeDetectorRef,
  AfterViewChecked
} from "@angular/core";
import { TableAbstractComponent } from "../../../../common-page-components/classes/table-abstract-component";
import { FiltersAthleteGeneralService } from "../../../services/filters-athlete-general.service";
import { AthleteCategoriesCombo } from "src/app/common-page-components/stores/filters-store/filters-store";
import { combineLatest, map, filter, mergeMap } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { IHeaderConfig } from "../../../../common-page-components/headers-component/headers-component.component";
import { FiltersAthleteWorldRankingsStatisticsService } from '../../services/filters-athlete-world-rankings-statistics.service';

@Component({
  selector: "app-athlete-career-statistics",
  templateUrl: "./athlete-career-statistics.component.html",
  styleUrls: ["./athlete-career-statistics.component.scss"]
})
export class AthleteCareerStatisticsComponent extends TableAbstractComponent
  implements OnInit, AfterViewChecked {
  /**
   * A property for select the hovered Tier
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  isHoveredTier = {};

  /**
   * A property for select the hovered match
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  isHoveredMatch = {};

  /**
   * Data of the table for shown
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  tableData = new BehaviorSubject([]);

  /**
   * A property for set the combo category an use with ease
   *
   * @type {AthleteCategoriesCombo}
   * @memberof AthleteCareerStatisticsComponent
   */
  comboCategories: AthleteCategoriesCombo = this.worldRankingFilter.categoryComboStats;

  /**
   * A property for set the filters of this page
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  filterInfo = [this.comboCategories && this.comboCategories.filterInfo ? this.comboCategories.filterInfo : null, this.common_filter.athleteStaticsticsDisciplineCombo.filterInfo]
    .filter(value => value != null);
  matchesView: string = "Matches-W-L";
  tierView: string = "Tiebreaks-W-L";
  constructor(
    injector: Injector,
    private common_filter: FiltersAthleteGeneralService,
    private chd: ChangeDetectorRef,
    public worldRankingFilter: FiltersAthleteWorldRankingsStatisticsService,
  ) {
    super(injector, common_filter, common_filter.athleteDetailStore);
    this.changeSort("DATE");
  }
  /**
   * Build headers of this page.
   *
   * The headers are different when isn't a selected category.
   */
  headers: Array<IHeaderConfig> = [
    { name: "Year", isSortable: true, sortProperty: "DATE" },
    { name: "Average Arrow", isSortable: true, sortProperty: "AVG" },
    // tslint:disable-next-line:max-line-length
    {
      name: "Matches",
      isSortable: true,
      sortProperty: "MATCHES",
      subHeaders: ["W-L", "WIN%"],
      subHeadersClasses: this.subHeaderMatchesClasses.bind(this)
    },
    // tslint:disable-next-line:max-line-length
    {
      name: "Tiebreaks",
      isSortable: true,
      sortProperty: "TIER",
      subHeaders: ["W-L", "WIN%"],
      subHeadersClasses: this.subHeaderTierClasses.bind(this)
    },
    { name: "Qualification best", isSortable: true, sortProperty: "QBEST" }
  ];

  /**
   *
   * @inheritdoc
   * @memberof AthleteCareerStatisticsComponent
   */
  ngOnInit() {
    this.subscriptions.push(
      this.comboCategories.comboData
        .pipe(
          combineLatest(
            this.reload.asObservable(),
            this.common_filter.storedId,
            this.common_filter.orderValue,
            this.common_filter.athleteStaticsticsDisciplineCombo.comboData
          ),
          map(([a, b, d, order, discipline]) => {
            const params = {
              Detailed: 1,
              Id: d.toString(),
              RBP: "ALL",
              CatId: a ? (a as any).CatId : undefined
            };
            return params;
          }),
          filter(a => a.CatId != undefined),
          mergeMap(params =>
            this.model.requestData(params, this.request_more_data)
          ),
          // Forward the combo data of discipline to allow filtering.
          mergeMap(requestResponse => this.common_filter.athleteStaticsticsDisciplineCombo.comboData)
        )
        .subscribe(next => {
          this.tableData.next(this.getYearsOfData(next.Name === 'Indoor'));
          this.chd.detectChanges();
        })
    );
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  ngOnDestroy(){
    super.ngOnDestroy();
    this.subscriptions.forEach(value => value.unsubscribe());
  }

  ngAfterViewChecked(): void {
    this.chd.detectChanges();
  }
  /**
   * A method for get the years of data
   *
   * @memberof AthleteCareerStatisticsComponent
   */
  getYearsOfData(isIndoor:boolean = false) {
    const targetDiscipline = !isIndoor ? this.data[0].Stats : this.data[0].IndoorStats
    if (!targetDiscipline || targetDiscipline.length === 0){
      return [];
    }
    const data = this.data.length > 0
      ? Object.keys(targetDiscipline)
        .filter(
          value =>
            value !== "Career" && value !== "Season" && value !== "LastSeason"
        )
        .map(key =>
          Object.assign(
            { Year: key, isHoveredMatch: false },
            targetDiscipline[key][0]
          )
        )
        .sort((f, s) => {
          switch (this.common_filter.sortLocator.sortingSend) {
            case "AVG":
              f.AverageArr == null ? (f.AverageArr = 0) : undefined;
              s.AverageArr == null ? (s.AverageArr = 0) : undefined;
              return f.AverageArr > s.AverageArr ? 1 : -1;
            case "-AVG":
              f.AverageArr == null ? (f.AverageArr = 0) : undefined;
              s.AverageArr == null ? (s.AverageArr = 0) : undefined;

              return f.AverageArr > s.AverageArr ? -1 : 1;
            case "DATE":
              return f.Year > s.Year ? 1 : -1;
            case "-DATE":
              return f.Year > s.Year ? -1 : 1;
            case "MATCHES":
              f.MatchWinPercentage == null
                ? (f.MatchWinPercentage = 0)
                : undefined;
              s.MatchWinPercentage == null
                ? (s.MatchWinPercentage = 0)
                : undefined;
              return f.MatchWinPercentage > s.MatchWinPercentage ? 1 : -1;
            case "-MATCHES":
              f.MatchWinPercentage == null
                ? (f.MatchWinPercentage = 0)
                : undefined;
              s.MatchWinPercentage == null
                ? (s.MatchWinPercentage = 0)
                : undefined;
              return f.MatchWinPercentage > s.MatchWinPercentage ? -1 : 1;
            case "TIER":
              f.TBWinPercentage == null ? (f.TBWinPercentage = 0) : undefined;
              s.TBWinPercentage == null ? (s.TBWinPercentage = 0) : undefined;
              return f.TBWinPercentage > s.TBWinPercentage ? 1 : -1;
            case "-TIER":
              f.TBWinPercentage == null ? (f.TBWinPercentage = 0) : undefined;
              s.TBWinPercentage == null ? (s.TBWinPercentage = 0) : undefined;
              return f.TBWinPercentage > s.TBWinPercentage ? -1 : 1;
            case "QBEST":
              f.QBest == null ? (f.QBest = 0) : undefined;
              s.QBest == null ? (s.QBest = 0) : undefined;
              return f.QBest > s.QBest ? 1 : -1;
            case "-QBEST":
              f.QBest == null ? (f.QBest = 0) : undefined;
              s.QBest == null ? (s.QBest = 0) : undefined;
              return f.QBest > s.QBest ? -1 : 1;
          }
        })
      : [];
      data.push( Object.assign(targetDiscipline['Career'][0], {Year:'Career'}))
      return data;
  }

  /**
   * Method to set the hover match
   *
   * @param {*} e native event
   * @param {*} key value of stats row
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  isHoverMatch(e, key) {
    e.stopPropagation();
    this.isHoveredMatch = key.index;
    return true;
  }

  /**
   * Method for unset the hover match
   *
   * @param {*} e native event
   * @param {*} key value of stats row
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  isNotHoverMatch(e, key) {
    this.isHoveredMatch = undefined;
    return false;
  }

  /**
   * Method for set the hover Tier
   *
   * @param {*} e native event
   * @param {*} key value of stats row
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  isHoverTier(e, key) {
    e.stopPropagation();
    this.isHoveredTier = key.index;
    return true;
  }
  /**
   * Method for unset the hover Tier
   *
   * @param {*} e native event
   * @param {*} key value of stats row
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  isNotHoverTier(e, key) {
    this.isHoveredTier = undefined;
    return false;
  }

  /**
   * Method for define the max value of a row in every column
   * @param {Array<any>} data Type that must be finded
   * @param {string} type Type that must be finded
   * @memberof AthleteCareerStatisticsComponent
   */
  isMaxValue(data: Array<any>, type: string) {
    let max;
    switch (type) {
      case "avg":
        max = arrayMax(
          data.map(value => value.AverageArr).filter(a => a != undefined)
        );
        return max !== 0 ? max : undefined;
      case "tier":
        max = arrayMax(
          data.map(value => value.TBWinPercentage).filter(a => a != undefined)
        );
        return max !== 0 ? max : undefined;
      case "match":
        max = arrayMax(
          data
            .map(value => value.MatchWinPercentage)
            .filter(a => a != undefined)
        );
        return max !== 0 ? max : undefined;
      case "qbest":
        max = arrayMax(
          data.map(value => value.QBest).filter(a => a != undefined)
        );
        return max !== 0 ? max : undefined;
    }
  }

  /**
   * A method for define the subheader action
   *
   * @param {string} subHeader subHeader id
   * @memberof AthleteCareerStatisticsComponent
   */
  subHeaderAction(subHeader: string) {
    if (subHeader.includes("Matches")) {
      this.matchesView = subHeader;
    } else {
      this.tierView = subHeader;
    }
  }

  /**
   * A method for check the subheader and set this class for update the style.
   *
   * @param {string} subHeader
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  subHeaderTierClasses(subHeader: string) {
    return { selected: subHeader === this.tierView };
  }

  /**
   * A method for check the subheader and set this class for update the style.
   *
   * @param {string} subHeader
   * @returns
   * @memberof AthleteCareerStatisticsComponent
   */
  subHeaderMatchesClasses(subHeader: string) {
    return { selected: subHeader === this.matchesView };
  }
}

/**
 * Check the array min value
 *
 * @param {*} arr
 * @returns
 */
export function arrayMin(arr) {
  return arr.reduce(function (p, v) {
    return p < v ? p : v;
  }, 0);
}

/**
 * Check the array max value
 *
 * @param {*} arr
 * @returns
 */
export function arrayMax(arr) {
  return arr.reduce(function (p, v) {
    return p > v ? p : v;
  }, 0);
}
